import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VirtualNumberService {

  constructor(private ws: PostmethodService) { }

  virtualNumCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "virtualNumberMaster");
  }
}
